const currentPaths = window.location.pathname.split('/').filter((el) => el.length > 0);
let base = '/';
if (currentPaths.length > 0 && currentPaths[0] !== 'admin') {
  base = currentPaths[0];
}

export default base;
